import { render, staticRenderFns } from "./promos.vue?vue&type=template&id=50b626a6&scoped=true&"
import script from "./promos.vue?vue&type=script&lang=js&"
export * from "./promos.vue?vue&type=script&lang=js&"
import style0 from "./promos.vue?vue&type=style&index=0&lang=css&"
import style1 from "./promos.vue?vue&type=style&index=1&id=50b626a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b626a6",
  null
  
)

export default component.exports